import React, { useEffect, useState } from "react";
import { Card, Table, Tag, Typography, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { fmtUnix } from "../log-utils";
import logApi from "../../../../api/log-api";

const { Text } = Typography;

// Bảng "nhóm lỗi trùng nhiều nhất" trong khoảng đang lọc.
//
// Một sự cố thường sinh hàng nghìn dòng giống hệt nhau (vd 151k dòng 429 trên
// /api/v1/user/login) — nhìn bảng phẳng không ra vấn đề, nhìn nhóm thì ra ngay.
// Bấm 1 nhóm sẽ đẩy path + status vào bộ lọc của bảng chi tiết bên dưới.
//
// filter    - bộ lọc hiện tại của tab Lỗi
// reloadKey - đổi để ép tải lại
// onPick    - ({ path, status_code }) → set filter cho bảng chi tiết
function ErrorGroupPanel({ filter, reloadKey, onPick }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(true);

    useEffect(() => {
        if (!open) return undefined;
        let cancelled = false;
        setLoading(true);
        logApi.getErrorGroups({ ...filter, limit: 20 })
            .then(({ data }) => { if (!cancelled) setRows(data.data || []); })
            .catch(() => { if (!cancelled) setRows([]); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadKey, open]);

    const columns = [
        {
            title: "Số dòng", dataIndex: "count", width: 100,
            render: (c) => <Text strong>{Number(c).toLocaleString("vi-VN")}</Text>,
        },
        {
            title: "Status", dataIndex: "status_code", width: 80,
            render: (c) => <Tag color={c >= 500 ? "red" : c >= 400 ? "orange" : "default"}>{c ?? "-"}</Tag>,
        },
        { title: "Loại", dataIndex: "error_type", width: 130 },
        { title: "Method", dataIndex: "method", width: 80 },
        { title: "Path", dataIndex: "path", ellipsis: true },
        { title: "Message mẫu", dataIndex: "sample_message", ellipsis: true },
        { title: "Lần đầu", dataIndex: "first_at", width: 140, render: fmtUnix },
        { title: "Gần nhất", dataIndex: "last_at", width: 140, render: fmtUnix },
    ];

    return (
        <Card
            size="small"
            className="shadow-sm"
            style={{ marginBottom: 16 }}
            title={
                <span>
                    <FontAwesomeIcon icon={faLayerGroup} className="mr-2 text-content-3" />
                    <Text strong>Nhóm lỗi trùng nhiều nhất</Text>
                </span>
            }
            extra={
                <Button size="small" type="link" onClick={() => setOpen((v) => !v)}>
                    {open ? "Ẩn" : "Hiện"}
                </Button>
            }
        >
            {open ? (
                <Table
                    rowKey={(r) => `${r.error_type}|${r.status_code}|${r.method}|${r.path}`}
                    size="small"
                    loading={loading}
                    columns={columns}
                    dataSource={rows}
                    pagination={false}
                    scroll={{ x: 1000, y: 260 }}
                    onRow={(r) => ({
                        onClick: () => onPick?.(r),
                        style: { cursor: "pointer" },
                    })}
                />
            ) : null}
        </Card>
    );
}

export default ErrorGroupPanel;
